// extracted by mini-css-extract-plugin
module.exports = {"title":"_2e0196","root":"_0ab8e6"};